
// 进度条
import './progressBar.less'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
export default {
  components: {
    VueSlider,
  },
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: [Number, String],
      default: 1000,
    },
    maskDot: {
      type: Array,
      default() {
        return []
      },
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      options: {
        railStyle: { background: '#666666', height: 12, 'border-radius': 0 },
        height: 6,
        processStyle: { background: '#259DD3', 'border-radius': 0 },
        dotSize: 12,
        tooltip: 'none',
      },
      marks: (val) => {
        const filter = this.maskDot.filter((el) => el.value === val)
        return filter.length > 0 ? {
          label: `${val}`
        } : false
      },
    }
  },
  render() {
    const slider = (
      <VueSlider {...{ props: this.options, scopedSlots: { ...this.$scopedSlots } }} value={this.value} on-drag-start={this.dragStart} max={this.max || this.value} onChange={this.change} marks={this.marks} >
        {Object.keys(this.$slots).map(name => (<template slot={name}>{this.$slots[name]}</template>))}
      </VueSlider >)
    return (<div>{slider}</div>)
  },
  methods: {
    change(value) {
      this.$emit('change', value)
    },
    dragStart(value) {
      this.$emit('dragStart', value)
    }
  },
}
